<label>Parts Used</label>

<div class='partRows'>
  @if (this.displayParts().length === 0) {
    <span class='text-muted'>No parts assigned yet</span>
  }
  @for (part of this.displayParts(); track part.id) {
    <div class='partRow'>
      <span class='partName'>{{ part.product.name }}</span>
      <span class='partQty'>x{{ part.qty }}</span>
      <button type='button' class='partRemove' (click)='this.removePart(part)' aria-label='Remove'>&times;</button>
    </div>
  }
</div>

<div class='form-row addPartRow'>
  <div class="form-group col-md-6">
    <ng-select [(ngModel)]="this.newProductId" class='form-control' (change)='this.newProductId = +$event'>
      @for (item of this.products; track item) {
        <ng-option [value]='item.id'>{{ item.name }}</ng-option>
      }
    </ng-select>
  </div>
  <div class="form-group col-md-2">
    <input type='number' min='1' step='1' name='qty' [(ngModel)]='this.newQty' class="form-control">
  </div>
  <div class="form-group col-md-4">
    <button type='button' class='btn btn-secondary' (click)='this.addPart()'><i class="fas fa-plus"></i> Add Part</button>
  </div>
</div>
